import type { ApexOptions } from 'apexcharts';

export function getApexChartTheme(isDark: boolean): Pick<ApexOptions, 'theme' | 'grid'> & {
  chart?: ApexOptions['chart'];
  legend?: ApexOptions['legend'];
  xaxis?: ApexOptions['xaxis'];
  yaxis?: ApexOptions['yaxis'];
} {
  const labelColor = isDark ? '#94a3b8' : '#6b7280';
  const foreColor = isDark ? '#e2e8f0' : '#374151';

  return {
    theme: { mode: isDark ? 'dark' : 'light' },
    chart: {
      foreColor,
      background: 'transparent',
    },
    grid: {
      borderColor: isDark ? '#334155' : '#E5E7EB',
      strokeDashArray: 4,
    },
    legend: {
      labels: { colors: foreColor },
    },
    xaxis: {
      labels: { style: { colors: labelColor, fontSize: '11px' } },
    },
    yaxis: {
      labels: { style: { colors: labelColor } },
    },
  };
}
